import { ScrollArea } from "@/components/ui/scroll-area";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

export default function Datenschutz({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] p-0" data-testid="datenschutz-dialog">
        <DialogHeader className="px-6 pt-6 pb-2">
          <DialogTitle className="font-['Manrope'] text-2xl font-bold text-slate-900">
            Datenschutzerklärung
          </DialogTitle>
          <DialogDescription className="text-sm text-slate-500">
            Informationen zum Datenschutz gemäß DSGVO
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="px-6 pb-6 max-h-[65vh]">
          <div className="space-y-6 text-sm text-slate-700 leading-relaxed pr-4">
            <section>
              <h3 className="font-semibold text-slate-900 mb-2">1. Datenschutz auf einen Blick</h3>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
                personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene
                Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-slate-900 mb-2">2. Verantwortlicher</h3>
              <p>
                Lehnen & Weinacht<br />
                Pflegeberatung & Alltagsbegleitung<br />
                Hochstr. 72<br />
                47929 Grefrath<br />
                Telefon: 0163 791 7044<br />
                E-Mail: lehnenundweinacht@gmail.com
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-slate-900 mb-2">3. Datenerfassung auf dieser Website</h3>

              <h4 className="font-medium text-slate-800 mt-3 mb-1">Cookies</h4>
              <p>
                Unsere Website verwendet Cookies. Das sind kleine Textdateien, die Ihr Webbrowser
                auf Ihrem Endgerät speichert. Cookies helfen uns dabei, unser Angebot
                nutzerfreundlicher und sicherer zu machen.
              </p>
              <p className="mt-2">
                Einige Cookies sind „Session-Cookies". Solche Cookies werden nach Ende Ihrer
                Browser-Sitzung von selbst gelöscht. Hingegen bleiben andere Cookies auf Ihrem
                Endgerät bestehen, bis Sie diese selbst löschen. Solche Cookies helfen uns, Sie bei
                Rückkehr auf unsere Website wiederzuerkennen.
              </p>

              <h4 className="font-medium text-slate-800 mt-3 mb-1">Kontaktformular</h4>
              <p>
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus
                dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks
                Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
                Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
              <p className="mt-2">
                Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) bzw. Art. 6 Abs. 1
                lit. f DSGVO (berechtigtes Interesse).
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-slate-900 mb-2">4. Terminbuchung über Calendly</h3>
              <p>
                Für die Online-Terminbuchung nutzen wir den Dienst Calendly (Calendly LLC, Atlanta,
                USA). Wenn Sie einen Termin buchen, werden folgende Daten an Calendly übermittelt:
              </p>
              <ul className="list-disc ml-5 mt-2 space-y-1">
                <li>Name</li>
                <li>E-Mail-Adresse</li>
                <li>Telefonnummer (optional)</li>
                <li>Gewählter Termin</li>
              </ul>
              <p className="mt-2">
                Calendly verarbeitet diese Daten in unserem Auftrag zur Terminkoordination.
                Weitere Informationen finden Sie in der{" "}
                <a
                  href="https://calendly.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-cyan-700 hover:underline"
                >
                  Datenschutzerklärung von Calendly
                </a>.
              </p>
              <p className="mt-2">
                Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Durchführung vorvertraglicher
                Maßnahmen).
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-slate-900 mb-2">5. Ihre Rechte</h3>
              <p>Sie haben jederzeit das Recht:</p>
              <ul className="list-disc ml-5 mt-2 space-y-1">
                <li><strong>Auskunft</strong> über Ihre bei uns gespeicherten Daten zu erhalten (Art. 15 DSGVO)</li>
                <li><strong>Berichtigung</strong> unrichtiger Daten zu verlangen (Art. 16 DSGVO)</li>
                <li><strong>Löschung</strong> Ihrer Daten zu verlangen (Art. 17 DSGVO)</li>
                <li><strong>Einschränkung</strong> der Verarbeitung zu verlangen (Art. 18 DSGVO)</li>
                <li><strong>Datenübertragbarkeit</strong> zu verlangen (Art. 20 DSGVO)</li>
                <li><strong>Widerspruch</strong> gegen die Verarbeitung einzulegen (Art. 21 DSGVO)</li>
              </ul>
              <p className="mt-2">
                Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht
                verstößt, haben Sie das Recht, sich bei einer Aufsichtsbehörde zu beschweren.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-slate-900 mb-2">6. SSL-/TLS-Verschlüsselung</h3>
              <p>
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
                vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte
                Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf
                „https://" wechselt.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-slate-900 mb-2">7. Speicherdauer</h3>
              <p>
                Personenbezogene Daten, die uns über unsere Website mitgeteilt worden sind, werden
                nur so lange gespeichert, bis der Zweck erfüllt ist, zu dem sie uns anvertraut
                wurden. Soweit handels- und steuerrechtliche Aufbewahrungsfristen zu beachten sind,
                kann die Speicherdauer bestimmter Daten bis zu 10 Jahre betragen.
              </p>
            </section>

            <div className="pt-4 border-t border-slate-200 text-xs text-slate-400">
              <p>
                <strong>Hinweis:</strong> Bitte ergänzen Sie die mit [Platzhalter] markierten Stellen
                mit Ihren tatsächlichen Angaben und lassen Sie die Datenschutzerklärung ggf. von
                einem Rechtsanwalt prüfen, bevor Sie die Website veröffentlichen.
              </p>
            </div>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
